import Motivos from "@/store/modules/Suspensiones/Motivos";
import PagoMinimo from "@/store/modules/Suspensiones/PagoMinimo";
import Evitar from "./Suspensiones/Evitar";
import EvitarSuspensiones from "./Suspensiones/EvitarSuspensiones";
import { get } from "lodash-es";
import axios from "axios";

export default {
  state: () => ({
    deudores: [],
    deudaAGestionar: null,
    suspensionesMODO: "evitar", // evitar | tratamiento
    mostrarTodos: 0,
  }),
  mutations: {
    setDeudores(state, payload) {
      state.deudores = payload;
    },
    setDeudaAGestionar(state, payload) {
      state.deudaAGestionar = payload;
    },
    setSuspensionesModo(state, payload) {
      state.suspensionesMODO = payload;
    },
    setMostrarTodos(state, payload) {
      state.mostrarTodos = payload;
    },
  },
  actions: {
    setMostrarTodos(context, payload) {
      context.commit("setMostrarTodos", payload);
    },
    async getDeudores(context) {
      const mostrarONoTodos = context.state.mostrarTodos;

      if (context.state.suspensionesMODO === "tratamiento") {
        try {
          const resp = await axios.post("/execute", {
            method: "CLI.GetClientesSuspendidos",
            parameters: [{ name: "mostrar_todos", value: mostrarONoTodos }],
          });
          if (get(resp, "data.ok", false)) {
            context.commit("setDeudores", get(resp, "data.result[0]"));
          }
          return resp.data;
        } catch (e) {
          console.log(e);
        }
      } else {
        try {
          const resp = await axios.post("/execute", {
            method: "CLI.GetTicketsDeClientes",
            parameters: [{ name: "mostrar_todos", value: mostrarONoTodos }],
          });
          if (get(resp, "data.ok", false)) {
            context.commit("setDeudores", get(resp, "data.result[0]"));
          }
          return resp.data;
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
  getters: {
    getDeudores(state) {
      return state.deudores;
    },
    getMostrarTodos(state) {
      return state.mostrarTodos;
    },
  },
  modules: {
    Motivos: {
      namespaced: true,
      ...Motivos,
    },
    PagoMinimo: {
      namespaced: true,
      ...PagoMinimo,
    },
    Evitar: {
      namespaced: true,
      ...Evitar,
    },
    EvitarSuspensiones: {
      namespaced: true,
      ...EvitarSuspensiones,
    },
  },
};
